<section *ngIf="checklistModel">
	<div class="site-log-header d-flex align-items-center justify-content-between mb-3">
		<div>
			<div class="site-log-header__customer text-uppercase fw-bold">
				{{ checklistModel.customerDisplayName || 'Customer' }}
			</div>
			<div class="text-muted small" *ngIf="checklistModel.jobNumber">Job: {{ checklistModel.jobNumber }}</div>
		</div>
		<div class="site-log-progress-ring" [style.background]="progressRingBackground" aria-label="Fleet completion progress">
			<span class="site-log-progress-ring__value">{{ progressPercent }}%</span>
		</div>
	</div>

	<p class="text-muted small mb-3" *ngIf="checklistModel.assets?.length">
		Progress applies to this job and is shared across all appointments on this job.
	</p>

	<div *ngIf="!checklistModel.assets?.length" class="alert alert-info">
		No fleet assets are configured for this customer. Add assets under Customer → Site Log.
	</div>

	<div *ngIf="checklistModel.assets?.length" class="table-responsive site-log-table-wrap">
		<table class="table table-sm table-bordered site-log-table mb-0">
			<thead>
				<tr>
					<th style="min-width: 140px;">Asset</th>
					<th *ngIf="checklistModel.showBeforePhotos" style="width: 95px;">Before Photos</th>
					<th *ngIf="checklistModel.showAfterPhotos" style="width: 95px;">After Photos</th>
					<th *ngIf="checklistModel.showDamage" style="width: 90px;">Damage</th>
					<th style="width: 90px;">Completed</th>
					<th style="min-width: 140px;">Completed By</th>
					<th style="min-width: 110px;">Date</th>
					<th style="min-width: 180px;">Note</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let item of checklistModel.assets">
					<td class="fw-semibold">{{ item.name }}</td>
					<td *ngIf="checklistModel.showBeforePhotos">
						<button type="button" class="btn btn-sm w-100"
							[class.btn-outline-primary]="(item.beforePhotoCount ?? 0) > 0"
							[class.btn-outline-secondary]="!(item.beforePhotoCount ?? 0)"
							(click)="openPhotos(item, 'Before')">
							{{ photoButtonLabel(item.beforePhotoCount ?? 0, 'Photos') }}
						</button>
					</td>
					<td *ngIf="checklistModel.showAfterPhotos">
						<button type="button" class="btn btn-sm w-100"
							[class.btn-outline-primary]="(item.afterPhotoCount ?? 0) > 0"
							[class.btn-outline-secondary]="!(item.afterPhotoCount ?? 0)"
							(click)="openPhotos(item, 'After')">
							{{ photoButtonLabel(item.afterPhotoCount ?? 0, 'Photos') }}
						</button>
					</td>
					<td *ngIf="checklistModel.showDamage">
						<button type="button" class="btn btn-sm"
							[class.btn-outline-primary]="(item.damagePhotoCount ?? 0) > 0"
							[class.btn-outline-secondary]="!(item.damagePhotoCount ?? 0)"
							(click)="openPhotos(item, 'Damage')">
							{{ photoButtonLabel(item.damagePhotoCount ?? 0, 'Damage') }}
						</button>
					</td>
					<td class="text-center">
						<input type="checkbox" class="form-check-input" [(ngModel)]="item.isCompleted" (ngModelChange)="onCompletedChange(item)" />
					</td>
					<td>
						<input type="text" class="form-control form-control-sm" [(ngModel)]="item.completedBy" [disabled]="!item.isCompleted" />
					</td>
					<td>
						<input type="text" class="form-control form-control-sm" readonly
							[value]="item.completedDate ? (item.completedDate | date:'M/d/yyyy') : ''" />
					</td>
					<td>
						<input type="text" class="form-control form-control-sm" [(ngModel)]="item.notes" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div class="row mt-3">
		<div class="col-12">
			<button type="button" class="save-button btn btn-outline-success me-3" (click)="onSave()" [slick-button-spinner]="spinnerStatus" [disabled]="!checklistModel.assets?.length">
				<i class="bi bi-check-circle"></i> Save
			</button>
			<button type="button" class="cancel-button btn btn-outline-danger" (click)="onCancel()">
				<i class="bi bi-x-circle"></i> Cancel
			</button>
		</div>
	</div>
</section>

<div *ngIf="isLoading" class="text-muted p-3">Loading site log...</div>

<site-log-asset-photos-dialog #assetPhotosDialogRef (photoCountChanged)="onPhotoCountChanged($event)"></site-log-asset-photos-dialog>
